module.exports = __webpack_public_path__ + "img/LaborEFZChemie-QMT-3217.5632dd5f.jpg";